import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_SuggestedFinding, SuggestedFindingDecision_Pending } from '@app/advisor-shared/_entity/suggested-finding/index';
import { ModuleFE_BaseAdvisorRuntime } from './ModuleFE_BaseAdvisorRuntime.js';
import { ModuleFE_AdvisorSession } from '../_entity/advisor-session/ModuleFE_AdvisorSession.js';
export const dispatch_onSuggestedFindingsUpdated = new ThunderDispatcherV3('__onSuggestedFindingsUpdated');
class ModuleFE_RuntimeSuggestedFinding_Class extends ModuleFE_BaseAdvisorRuntime {
    constructor() {
        super(DBDef_SuggestedFinding, dispatch_onSuggestedFindingsUpdated);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.patientFilter);
    }
    getForVariableId = (variableId) => {
        return this.cache.find(item => item.variableId === variableId && item.decision === SuggestedFindingDecision_Pending);
    };
}
export const ModuleFE_SuggestedFinding = new ModuleFE_RuntimeSuggestedFinding_Class();
//# sourceMappingURL=ModuleFE_SuggestedFinding.js.map